/* eslint-disable no-console */
import Clarity from "@microsoft/clarity";

export interface ClarityConfig {
  projectId: string;
  upload?: string;
  delay?: number;
  sessionReplay?: boolean;
  heatmap?: boolean;
  privacy?: {
    maskTextInputs?: boolean;
    maskAllText?: boolean;
    maskUserImages?: boolean;
    maskEmails?: boolean;
    maskPhoneNumbers?: boolean;
  };
}

export interface ClarityEvent {
  name: string;
  data?: Record<string, any>;
}

export const defaultClarityConfig: ClarityConfig = {
  projectId: process.env.REACT_APP_CLARITY_PROJECT_ID as string,
  upload: "https://c.clarity.ms/collect",
  delay: 1000,
  sessionReplay: true,
  heatmap: true,
  privacy: {
    maskTextInputs: true,
    maskAllText: false,
    maskUserImages: true,
    maskEmails: true,
    maskPhoneNumbers: true,
  },
};

let isInitialized = false;
let config: ClarityConfig | null = null;

export const initClarity = (): void => {
  if (isInitialized) {
    return;
  }

  if (!defaultClarityConfig.projectId) {
    throw new Error("Project ID é obrigatório para inicializar o Clarity");
  }

  config = defaultClarityConfig;
  Clarity.init(config.projectId);
  isInitialized = true;
};

/**
 * Envia um evento customizado para o Clarity
 */
export const trackClarityEvent = (event: ClarityEvent): void => {
  try {
    Clarity.event(event.name);
  } catch (error) {
    console.error("Erro ao enviar evento para o Clarity:", error);
  }
};

/**
 * Identifica um usuário no Clarity
 */
export const identifyClarityUser = (userId: string): void => {
  try {
    Clarity.identify(userId);
  } catch (error) {
    console.error("Erro ao identificar usuário no Clarity:", error);
  }
};

/**
 * Define metadados para a sessão atual
 */
export const setClarityMetadata = (metadata: Record<string, any>): void => {
  try {
    Clarity.setTag("metadata", Object.keys(metadata).join(","));
  } catch (error) {
    console.error("Erro ao definir metadados no Clarity:", error);
  }
};

// Exporta um objeto com todas as funções para compatibilidade
export const clarityManager = {
  init: initClarity,
  trackEvent: trackClarityEvent,
  identify: identifyClarityUser,
  setMetadata: setClarityMetadata,
};

export default clarityManager;
